// Переключатель-тумблер. Живёт здесь, а не в Notifications, потому что нужен
// и в профиле: голосовые ответы переехали туда — это способ ответа, а не
// уведомление, и на экране «Уведомления» его никто не искал.

export function Toggle({
  checked,
  disabled,
  onChange,
  label,
}: {
  checked: boolean
  disabled?: boolean
  onChange: () => void
  label?: string
}) {
  return (
    <button
      onClick={onChange}
      disabled={disabled}
      className="relative inline-flex h-6 w-11 shrink-0 rounded-full border-2 border-transparent focus:outline-none disabled:opacity-40"
      style={{
        backgroundColor: checked ? 'var(--color-accent)' : 'var(--color-bg-3)',
        // Цвету перелёт не нужен: «проскочить» и вернуться он не может, а
        // пружинная кривая на нём — просто более вялая. Перелёт остаётся
        // у ручки ниже, там он и читается.
        transition: 'background-color 200ms cubic-bezier(0.23, 1, 0.32, 1)',
      }}
      role="switch"
      aria-checked={checked}
      aria-label={label}
    >
      <span
        className="inline-block h-5 w-5 rounded-full bg-white shadow"
        style={{
          transform: checked ? 'translateX(20px)' : 'translateX(0)',
          transition: 'transform 200ms cubic-bezier(0.34, 1.56, 0.64, 1)',
        }}
      />
    </button>
  )
}
